import CountryID from 'types/CountryID';

export const UNITED_STATES_ID = 313 as CountryID;
export const HAWAII_ID = 366 as CountryID;
